import NavbarPill from "./NavbarPill";
import Footer from "./Footer";
import FixingGold from "./FixingGold";
import { Outlet } from "react-router-dom";

export default function Layout() {
    return (
        <div>
            <NavbarPill />
            <Outlet />
            <FixingGold />
            <Footer />
        </div>
    );
}